import {
    getMissingPayments,
    insertMissingPayment
  } from "../../services/paymentRecovery.service";
  
  const state = {
    missingPayments: [],
  };
  
  const mutations = {
    SET_MISSING_PAYMENTS(state, payments) {
      state.missingPayments = payments;
    },
  };
  
  const actions = {
    async getMissingPayments(vuexContext) {
      return await getMissingPayments().then(async (response) => {
        vuexContext.commit("SET_MISSING_PAYMENTS", response.data.data);
        return response.data;
      });
    },
    async insertMissingPayment(vuexContext, data) {
      return await insertMissingPayment(data).then(async (response) => {
        return response.data;
      });
    },
  };
  
  const getters = {
    missingPayments(state) {
      return state.missingPayments;
    },
  };
  
  export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  };
